<template>
  <generic-container
    :searchable="false"
    :show_plus="true"
    icon="check"
    :title="$t('outcomes')"
    @add="add"
    class="ui form"
  >
    <div
      class="fields"
      v-for="(arg, index) in outcomes"
      v-bind:key="index"
      style="margin-bottom: 10px"
    >
      <div class="three wide column field">
        <label for v-if="index == 0">{{ $t("name") }}</label>
        <input type="text" v-model="outcomes[index].name" name="name" />
      </div>
      <div class="three wide column field">
        <label for v-if="index == 0">{{ $t("icon") }}</label>
        <div class="ui left icon input">
          <input type="text" v-model="outcomes[index].icon" name="icon" />
          <i :class="arg.icon + ' icon'"></i>
        </div>
      </div>
      <div class="three wide column field">
        <label for v-if="index == 0">{{ $t("validation") }}</label>
        <div class="ui toggle checkbox" style="margin-top: 8px">
          <input
            type="checkbox"
            v-model="outcomes[index].validate"
            name="validate_fields"
          />
          <label>{{ $t("validate fields") }}</label>
        </div>
      </div>
      <!-- <div class="two wide column field">
              <label for>{{ $t("color") }}</label>
              <swatches colors="material-basic" shapes="circles" v-model="outcomes[index].color" />
      </div>-->
      <div class="four wide column field">
        <label for v-if="index == 0">{{ $t("preview") }}</label>
        <div class="ui basic icon labeled button">
          <i :class="arg.icon + ' icon'"></i>
          {{ arg.name }}
        </div>
      </div>
      <div class="one column width field">
        <label for v-if="index == 0">{{ $t("actions") }}</label>
        <div class="ui mini icon red button" @click="remove(arg, index)">
          <i class="trash icon"></i>
        </div>
      </div>
    </div>
  </generic-container>
</template>

<script>
import GenericContainer from "@/components/GenericContainer";
import filters from "@/filters";

export default {
  name: "OutcomeManagement",
  filters: filters,
  props: { human_task: Object },
  components: {
    GenericContainer,
  },
  data() {
    return {
      outcomes: [],
    };
  },
  methods: {
    add() {
      let outc = {
        name: "",
      };
      this.outcomes.push(outc);
    },
    remove(arg, index) {
      this.outcomes.splice(index, 1);
    },
  },
  mounted() {
    let vm = this;
    setTimeout(function () {
      if (vm.$props.human_task.uuid) {
        vm.outcomes = vm.$props.human_task.outcomes;
      }
    }, 2000);
  },
  watch: {},
};
</script>
